import React, { useContext } from 'react';
import { BaseDataContext } from '../../Context/BaseDataContext';
import NumberFormat from 'react-number-format';

function CabintypeSelect(props) {
  const [baseData, setBaseData] = useContext(BaseDataContext);

  function renderPrice(price) {
    return <NumberFormat
      value={price}
      decimalScale={0}
      displayType={'text'}
      decimalSeparator={','}
      thousandSeparator={'.'}
      prefix={'DKK '}
    />
  }
  function hasEqualPersons(obj1, obj2) {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    for (let objKey of obj1Keys) {
      if (objKey != "cabintypeId" && obj2Keys.includes(objKey)) {
        if (obj1[objKey] != obj2[objKey]) {
          return false;
        }
      }
    }

    return true;
  }
  function renderMainContent() {
    let grid = props.cruisepackage.priceGrids.find(x => hasEqualPersons(x, props.cabin));
    if (grid) {
      let cabintypes = baseData.cabinprimarytypes;
      const test = props.ship;
      let gridRow = grid.priceGridRows.find(x => x.cabinCategoryPrimaryTypeId === props.cabin.cabintypeId);
      if (gridRow) {
        return <div className="border p-2 mb-4">
          <p>{cabintypes.find(x => x.id === gridRow.cabinCategoryPrimaryTypeId).name}</p>
          {gridRow.priceGridCell.priceGridCellPrices.map((priceObject, index) =>
            <div key={gridRow.cabinCategoryPrimaryTypeId + '_' + index}
              className="flex justify-between border p-2">
              <span className="w-1/3">{props.ship.cabinCategories.find(x => x.id === priceObject.cabinCategoryId).name}</span>
              <span className="w-1/3">{priceObject.promotionName}</span>
              <span className="w-1/3 text-right">{renderPrice(priceObject.price/100)}</span>
            </div>
          )}
        </div>
      }
    }
  }

  return (
    <React.Fragment>
      {renderMainContent()}
    </React.Fragment>
  );
};

export default CabintypeSelect;